import React from 'react';
import { Alert, Snackbar as MuiSnackbar } from '@mui/material';

interface SnackbarState {
  open: boolean;
  message: string;
  severity: 'warning' | 'info' | 'error' | 'success';
}

interface IProps {
  snackbar: SnackbarState;
  onClose: (event: React.SyntheticEvent | Event, reason?: string) => void;
}

const Snackbar: React.FC<IProps> = ({ snackbar, onClose }) => {
  return (
    <MuiSnackbar
      open={snackbar.open}
      autoHideDuration={3000}
      onClose={onClose}
    >
      <Alert
        onClose={onClose}
        severity={snackbar.severity}
        sx={{ width: "100%" }}
      >
        {snackbar.message}
      </Alert>
    </MuiSnackbar>
  );
}; 

export default Snackbar; 